import { render, staticRenderFns } from "./loading-general.vue?vue&type=template&id=f2cc4b04&"
import script from "./loading-general.vue?vue&type=script&lang=js&"
export * from "./loading-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports